import { isSafari } from "react-device-detect";
import { Tooltip as ReactTooltip } from "react-tooltip";
import './PrintButton.scss';

export const PrintButton = (props: {disabled?: boolean}) => {
    function tooltipsSection() {
        return <>
            <ReactTooltip
                id='safari'
                className="tooltip print-button-tooltip-element"
                place="top"
                content="Tisk je optimalizován pro prohlížeč Chrome. Na jiných prohlížečích nemusí správně fungovat."
            />
        </>
    }

    return <>
        <button
            className={`print-hidden print-button py-2.5 px-5 mb-2.5 ${props.disabled ? 'disabled opacity-50 cursor-not-allowed' : ''} ${isSafari ? 'safari hover:bg-pink-300 hover:opacity-70' : ''}`}
            data-tooltip-id={`${isSafari ? 'safari' : ''}`}
            onClick={() => {
                window.print()
            }}
            disabled={props.disabled}
        >
            Tisk
        </button>
        {tooltipsSection()}
        <div className={`print-alert w-full px-[50px] text-gray-500 flex justify-center ${isSafari ? 'print-hidden' : 'hidden'}`}>
            <span className="print-alert-text block text-center text-xs w-[300px]">
                Tiskový výstup je optimalizován pro prohlížeč Chrome. Na jiných prohlížečích vám nemusí správně fungovat.
            </span>
        </div>
    </>
}